import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

import { FeatureManagementRoutingModule } from './feature-management-routing.module';
import { FeatureListComponent } from './components/feature-list/feature-list.component';
import { FeatureEditorComponent } from './components/feature-editor/feature-editor.component';
import { FeatureManagementContainerComponent } from './components/feature-management-container/feature-management-container.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { FeatureManagementService } from './services/feature-management.service';
import { UserService, USER_SERVICE_CONFIG } from '@overtur-monorepo/keying-user';
import { environment } from '../../../../apps/keycom/src/environments/environment';
import { AppContainerModule } from '../../../../apps/keycom/src/app/app-container/app-container.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatMenuModule,
    MatTooltipModule,
    MatRadioModule,
    MatSliderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    FeatureManagementRoutingModule,
    AppContainerModule,
  ],
  declarations: [
    FeatureListComponent,
    FeatureEditorComponent,
    FeatureManagementContainerComponent,
    ConfirmationDialogComponent
  ],
  providers: [
    FeatureManagementService,
    UserService,
    {
      provide: USER_SERVICE_CONFIG,
      useValue: { baseUrl: `${environment.masterKeyApiUrl}/v1` }
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
})
export class FeatureManagementModule {}
